import { motion } from 'framer-motion';
import { iconsSources } from '../../helpers/icons';
import { hideNumber } from '../../helpers/titreHelper';

import { Confetti } from '../Confetti/Confetti';
import styles from './Winners.module.css';

import bgDefaultVideo from '../../assets/video/bgVideo.webm';
import posterDefault from '../../assets/images/bgPoster.webp';

import logo from '../../assets/images/logo.png';
import delo from '../../assets/images/delo.png';
import ncsp from '../../assets/images/ncsp.png';

export const Winners = ({ winnerMessages }) => {
  const errorHandler = (e, channel) => {
    e.target.src = iconsSources[channel];
  };

  const winnerWord = winnerMessages?.length > 1 ? 'ПОБЕДИТЕЛИ!' : 'ПОБЕДИТЕЛЬ!';
  const letters = winnerWord.split('');

  const initDelay = 0.6;

  return (
    <div className={styles.wrapper}>
      <img src={logo} alt="logo" className={styles.logo} />
      <img src={delo} alt="delo" className={styles.delo} />
      <img src={ncsp} alt="ncsp" className={styles.ncsp} />

      <div className={styles.firstLine}>
        {letters.map((l, idx, arr) => {
          let initialIdx = 4;
          let oneLetterWidth = 7;
          let initialX = `${(idx - initialIdx) * oneLetterWidth * -1}rem`;

          return (
            <motion.div
              style={{ position: 'relative', zIndex: idx * -1 }}
              key={idx}
              initial={{
                scale: 0,
                x: initialX,
              }}
              animate={{
                scale: 1,
                x: 0,
              }}
              transition={{
                duration: 0.5,
                delay: idx * 0.05 + initDelay,
              }}
            >
              {l}
            </motion.div>
          );
        })}
      </div>

      {winnerMessages && (
        <div className={styles.winnersWrapper}>
          {winnerMessages.slice(0, 3).map((win, i) => {
            const { message } = win;
            return (
              <div
                className={styles.avatarBlock}
                key={message?.author + message.id}
              >
                <div className={styles.avatar}>
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{
                      duration: 1,
                      delay: 0.2 + i * 0.36 + initDelay,
                    }}
                    className={styles.avatarBg}
                    style={{
                      background: `url(${
                        iconsSources[message?.channel]
                      }) center/cover no-repeat `,
                    }}
                  />
                  <motion.img
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{
                      duration: 1,
                      delay: 0.2 + i * 0.36 + initDelay,
                    }}
                    src={
                      (message?.image !== '1' && message?.image) ||
                      iconsSources[message?.channel]
                    }
                    alt=""
                    onError={(e) => errorHandler(e, message?.channel)}
                  />
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 1, delay: i * 0.36 + initDelay }}
                    className={styles.backImg}
                  />
                </div>

                <div
                  className={styles.author}
                  style={{ '--delayAuthor': `${i * 0.36 + initDelay}s` }}
                >
                  {message.author || hideNumber(message?.senderNumber)}
                </div>
              </div>
            );
          })}
        </div>
      )}

      <Confetti
        startDelay={winnerMessages?.slice(0, 3)?.length * 700 + 600 || 2600}
      />

      <motion.video
        key="winnerVideo"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={posterDefault}
      >
        <source src={bgDefaultVideo} type="video/webm"></source>
      </motion.video>
    </div>
  );
};
